import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { GenericAlertPopupComponent } from '../../shared/generic-alert-popup/generic-alert-popup.component';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
	providedIn: 'root'
})
export class ConsumerQuizService {
	inProgress: boolean = false;
	idCourse!: string;

	constructor(
		private dialog: MatDialog,
		private translateService: TranslateService
	) {
	}

	Progress(idCourse?: string) {
		this.idCourse = idCourse;
		this.inProgress = true;
	}

	clearQuizProgress() {
		this.inProgress = false;
		this.idCourse = '';
	}

	async openPopup() {
		const dialog = this.dialog.open(GenericAlertPopupComponent, {
			width: '550px',
			minHeight: '233px',
			maxHeight: '250px',
			data:
			{
				title: 'consumer-quiz.want_leave',
				description: 'consumer-quiz.you_lose_progress_quiz',
				dismissBtnText: 'general.cancel',
				acceptBtnText: 'general.leave',
				btnColor: 'primary'
			},
			disableClose: true
		});

		const dialogData = await firstValueFrom(dialog.afterClosed());
		if (dialogData) {
			this.clearQuizProgress();
		}
		return dialogData
	}
}
